import React, { useState, useMemo } from "react";

const PALETTE = [
    "#FF6B00",
    "#138808",
    "#0F172A",
    "#7C3AED",
    "#0891B2",
    "#DB2777",
    "#16A34A",
    "#EA580C",
    "#2563EB",
    "#9333EA",
];

function colorFor(name) {
    if (!name) return PALETTE[0];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
    }
    return PALETTE[hash % PALETTE.length];
}

/**
 * Logo with a 3-tier fallback:
 *   1. Clearbit (provided via `src`)
 *   2. Google favicon for the same domain
 *   3. Letter avatar with stable color hash from name
 */
export default function LogoImage({
    src,
    domain,
    name,
    size = 64,
    rounded = "rounded-xl",
    className = "",
}) {
    const [stage, setStage] = useState(0); // 0=clearbit, 1=favicon, 2=letter
    const initial = (name || "?").trim().charAt(0).toUpperCase();
    const bg = useMemo(() => colorFor(name), [name]);

    const fav = domain
        ? `https://www.google.com/s2/favicons?domain=${domain}&sz=128`
        : null;

    if (stage < 2) {
        const url = stage === 0 ? src : fav;
        if (!url) {
            // Skip directly to letter avatar
            return (
                <div
                    className={`flex items-center justify-center text-white font-heading font-bold ${rounded} ${className}`}
                    style={{
                        width: size,
                        height: size,
                        background: bg,
                        fontSize: size * 0.42,
                    }}
                    aria-label={name}
                >
                    {initial}
                </div>
            );
        }
        return (
            <img
                src={url}
                alt={`${name} logo`}
                width={size}
                height={size}
                onError={() => setStage(stage + 1)}
                className={`object-contain bg-white border border-line ${rounded} ${className}`}
                style={{ width: size, height: size, padding: size > 48 ? 8 : 4 }}
                loading="lazy"
            />
        );
    }

    return (
        <div
            className={`flex items-center justify-center text-white font-heading font-bold ${rounded} ${className}`}
            style={{
                width: size,
                height: size,
                background: bg,
                fontSize: size * 0.42,
            }}
            aria-label={name}
        >
            {initial}
        </div>
    );
}
